import { ToastContainer, toast } from 'react-toastify';

export function callErrorNotification (message) {
  toast.error(message, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose:3000
  });
}

export function callSuccessNotification (message) {
  toast.success(message, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose:3000
  });
}

export function callInfoNotification (message) {
  toast.info(message, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose:3000
  });
}

export function callWarningNotification (message) {
  toast.warn(message, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose:3000
  });
}

export default ToastContainer;



// WEBPACK FOOTER //
// ./src/components/Notification/index.js